const actionTypeIdentifier = 'BNI7602J-1L3K-10BD-JK81-FS4H6S0CIM09'; //this is a newid

export const getCostCenter = `GET-COST-CENTER-${actionTypeIdentifier}`;
export const setCostCenterError = `SET-COST-CENTER-ERROR-${actionTypeIdentifier}`;
export const setCostCenterColSearchStr = `SET-COST-CENTER-COLUMN-SEARCH-STR-${actionTypeIdentifier}`;
export const sortCostCenterItems = `SORT-COST-CENTER-ITEMS-${actionTypeIdentifier}`;
export const setCostCenterPageSize = `SET-COST-CENTER-PAGE-SIZE-${actionTypeIdentifier}`;
export const setCostCenterFilter = `SET-COST-CENTER-FILTER-${actionTypeIdentifier}`;
export const applyCostCenterFilter = `APPLY-COST-CENTER-FILTER-${actionTypeIdentifier}`;
export const setDefaultCostCenter = `SET-DEFAULT-COST-CENTER-${actionTypeIdentifier}`;
export const getCostCenterDropdownList = `GET-COST-CENTER-DROPDOWN-LIST-${actionTypeIdentifier}`;
export const getCostCenterbyId = `GET-COST-CENTER-BY-ID-${actionTypeIdentifier}`;
export const getCostCenterAuthorizers = `GET-COST-CENTER-AUTHORIZERS-${actionTypeIdentifier}`;
export const setCostCenterAuthorizerLoad =  `GET-COST-CENTER-AUTHORIZERS-LOAD-${actionTypeIdentifier}`;
export const setResetCostCenterAuthorize = `GET-RESET-COST-CENTER-AUTHORIZERS-${actionTypeIdentifier}`;
export const setCostCenterCurrenciesLoad =  `GET-COST-CENTER-CURRENCIES-LOAD-${actionTypeIdentifier}`;
export const setResetCostCenterCurrencies = `GET-RESET-COST-CENTER-AUTHORIZERS-${actionTypeIdentifier}`;
export const getCostCenterCurrencies = `GET-COST-CENTER-CURRENCIES-${actionTypeIdentifier}`;
export const costCenterModel = {
    costCenterId: 0,
    costCenter: "",
    costCenterDescription: "",
    companyCode: "",
    companyCodeDescription: "",
    authorizer: "",
    profitCenter: "",
    currency: "",
    status: "",
    validFrom: "",
    validTo: ""
}